import { IntervalTexts } from '../utils/metric';

export const krdetailConstants = {
  GET_KRDETAILS_SUCCSESS: "GET_KRDETAILS_SUCCSESS",
  UPDATE_INITIAL_PROPS: "UPDATE_INITIAL_PROPS",
  HANDLE_KEBAB_MENU: "HANDLE_KEBAB_MENU",
  GET_GRAPH_DATA_SUCCESS: "GET_GRAPH_DATA_SUCCESS",
  GET_GRAPH_DATA_FAIL: "GET_GRAPH_DATA_FAIL",
  DATA_SOURCE_SUCCESS: "DATA_SOURCE_SUCCESS",
  DATA_SOURCE_FAIL: "DATA_SOURCE_FAIL",
  GET_KR_ATTACHMENT_SUCCESS: "GET_KR_ATTACHMENT_SUCCESS",
  GET_KR_ATTACHMENT_FAIL: "GET_KR_ATTACHMENT_FAIL",
  KR_ATTACHMENT_DELETE_SUCCESS: "KR_ATTACHMENT_DELETE_SUCCESS",
  KR_ATTACHMENT_DELETE_FAILURE: "KR_ATTACHMENT_DELETE_FAILURE",
  SAVE_KR_ATTACHMENTS_SUCCSESS: "SAVE_KR_ATTACHMENTS_SUCCSESS",
  SAVE_KR_ATTACHMENTS_FAIL: "SAVE_KR_ATTACHMENTS_SUCCSESS",
  MENTION_USER_LISTS: "MENTION_USER_LISTS",
  MENTION_USER_LISTS_EMPTY: "MENTION_USER_LISTS_EMPTY",
  GET_CASCADE_TREE_SUCCESS: "GET_CASCADE_TREE_SUCCESS",
  GET_CASCADE_TREE_FAIL: "GET_CASCADE_TREE_FAIL",
  SAVE_KR_NOTE: "SAVE_KR_NOTE",
  GET_METRIC_BY_GOAL: "GET_METRIC_BY_GOAL",
  DATA_FLOW_TREE_STATUS: "DATA_FLOW_TREE_STATUS",
  GET_GRAPH_DATA_UPD: "GET_GRAPH_DATA_UPD",
  GET_ALIGN_TREE_DATA: "GET_ALIGN_TREE_DATA",
  UPDATE_KR_REACTED_EMOJI: "UPDATE_KR_REACTED_EMOJI",
  UPDATE_METRIC_ATTRIBUTES: "UPDATE_METRIC_ATTRIBUTES",
  UPDATE_KR_HEADER_CONFIDENCE: "UPDATE_KR_HEADER_CONFIDENCE",
  GET_UPDATE_KR_CONFIDENCE: "GET_UPDATE_KR_CONFIDENCE",
  UPDATE_CLUSTER_SIMILAR_DATA: "UPDATE_CLUSTER_SIMILAR_DATA",
  COPY_KR_DATA_UPDATE: "COPY_KR_DATA_UPDATE",
  UPDATE_FUS_KR_ATTACHMENT_SUCCESS: 'UPDATE_FUS_KR_ATTACHMENT_SUCCESS',

  //kr source types
  SOURCE_PERSON: 1,
  SOURCE_WORKSTREAM: 2,
  SOURCE_METRICS: 3,
  SOURCE_AVG_CYCLE_TIME: 4,
  SOURCE_SURVEY: 5,
  SOURCE_OUTSIDE_WORKBOARD: 6,
  SOURCE_OTHER_GOALS: 7,
  SOURCE_EXT_SOURCES: 8,
  SOURCE_CASCADE_RESULTS: 9, //only for UI, not using in db
  SOURCE_DATA_STREAMS: 10,
  SOURCE_MIRROR_KR: 11,
  SOURCE_MIT_PERSON: 12,
  SOURCE_MIT_DATA_STREAMS: 13,
  SOURCE_DISTINCT_KR:14,

  TYPE_REGULAR: 1,
  TYPE_CASCADE: 2,

  // @TODO: Move these to kpiMarketplace.constants.js as each is
  //  removed or changed to v2 contract.
	JIRA_ID  : 5,
	ASANA_ID : 6,
  MS_PLANNER_ID : 11,
  AZURE_CLOUD_ID : 13,
  IFRAME_HOSTED_EXT_SOURCE_ID : 15,
  SALESFORCE_APP_ID: 17,
  RALLY_APP_ID: 18,
  POWERBI_APP_ID: 19,
  SMARTSHEET_ID: 21,
  TABLEAU_ID: 22,
  EXCEL_ID: 23,
  SNOWFLAKE_ID: 24,
  GSHEET_ID: 25,
  TRELLO_ID: 26,
  GREENHOUSE_ID: 27,
  JIRA_KPI_ID: 28,
  GITLAB_ID: 29,
  ASANA_KPI_ID: 30,
  HUBSPOT_ID: 38,
  MONDAY_KPI_ID: 39,
  WOBO_KPI_ID: 40,
  AZURE_DEVOPS_KPI_ID: 41,
  MS_PLANNER_KPI_ID: 42,
  WRIKE_KPI_ID: 44,

  //kr graph types
  PIE_CHART: 1,
  BAR_CHART: 2,
  LINE_CHART: 3,
  STACKED_BAR_CHART: 5,
  RANGE_CHART: 6,
  THRESHOLD_CHART: 7,

  //kr interval
  INTERVAL_DAY: 1,
  INTERVAL_WEEK: 2,
  INTERVAL_MONTH: 3,
  INTERVAL_QUARTER: 4,
  INTERVAL_ONCE: 5,
  INTERVAL_BIWEEKLY: 6,
  INTERVAL_BIQUARTERLY: 7,
  INTERVAL_TRIMESTER: 8,

  //kr counting
  METRIC_UNKNOWN: 0,  // Known issue with WS KRs not setting their counting value
  METRIC_COUNTING_UP: 1,
  METRIC_COUNTING_DOWN: 2,
  METRIC_COUNTING_THRESHOLD: 3,
  METRIC_COUNTING_RANGE: 4,
  METRIC_COUNTING_SURVEY_YES_NO: 5,
  METRIC_COUNTING_SURVEY_SCALE: 6,

  //kr metric
  METRIC_NUMBER: 1,
  METRIC_DOLLAR: 2,
  METRIC_PERCENTAGE: 3,
  METRIC_AVG_CYCLE_TIME: 4,

  //kr progress type
  PROGRESS_TYPE_LAST_UPDATE: 1,
  PROGRESS_TYPE_TOTAL: 2,
  PROGRESS_TYPE_AVERAGE: 3,
  PROGRESS_TYPE_SUM_LAST_UPDATE: 4,

  //goal status
  GOAL_ACTIVE: 1,
  GOAL_DELETED: 0,
  GOAL_CLOSED: 2,

  METRIC_ACTIVE: 1,
  METRIC_CLOSED: 2,
  ACTIVITY_KR_CLOSED: 'kr closed',
  ACTIVITY_KR_REOPENED: 'kr reopened',

  // confidence — mirrors Confidence::*
  CONFIDENCE_LOW: 1,
  CONFIDENCE_MEDIUM: 2,
  CONFIDENCE_HIGH: 3,
  CONFIDENCE_LOW_TEXT: 'Low',
  CONFIDENCE_MEDIUM_TEXT: 'Medium',
  CONFIDENCE_HIGH_TEXT: 'High',

   //krs that allow automate target value check
  KRS_AUTOMATE_TARGET: ['18', '21', '26', '30'],

  KRS_NO_CURRENCY: ['18', '26', '27', '29', '30'],
};

export const krdetailMetricConst = IntervalTexts;

export const metricEventPageRef = {
  2: "DS_WORSKTREAM",
  3: "DS_ROLL_UP_KR",
  5: "DS_SURVEY",
  7: "DS_ROLL_UP_OKR",
  9: "DS_CASCADE",
  10: "DS_DATASTREAM",
  11: "DS_MIRROR",
};
export const metricEventPageRefExtSrc = {
  5: "DS_JIRA",
  6: "DS_ASANA",
  11: "DS_MS_PLANNER",
  13: "DS_ADO",
};
export const updateDisabledMessage = 'Modifying previously saved data is blocked per request of the organization';
export const updateDisabledMessageWithGracePeriod = "Your organization's policy prohibits modifying saved data after $NumOfDays days from the designated time period.";

export const KR_TYPES = {
	1: "person",
	2: "workstream",
	3: "rollupokrs",
	5: "survey",
	7: "rollupokrs",
	8: "kpi",
	9: "cascade",
	10: "kpi",
	11: "mirrorkr",
	12: "multipleIntervalTargets",
	13: "multipleIntervalTargets",
	15: "krstudio",
	14:"multipleIntervalTargets"
};